'use es6';

import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { LAYOUTS, getLayoutForSection } from 'EmailEditorUI/constants/SectionLayoutConstants';
import { MODULE_TYPES, getModuleType } from 'EmailData/constants/DefaultModulesConstants';
export const trackEmailAddressVerificationSent = location => {
  UsageTracker.trackEditorInteraction({
    action: 'Email Address Verification Action',
    event: 'Address verification email sent',
    location
  });
};
export const trackUnverifiedAddressWarning = () => {
  UsageTracker.trackEditorInteraction({
    action: 'Email Address Verification Action',
    event: 'Unverified address blocked'
  });
};
const LAYOUT_TYPES_FOR_LOGGING = {
  [LAYOUTS.ONE_COLUMN]: 'layout 1 column',
  [LAYOUTS.TWO_COLUMN]: 'layout 2 column',
  [LAYOUTS.THREE_COLUMN]: 'layout 3 column',
  [LAYOUTS.FOUR_COLUMN]: 'layout 4 column',
  [LAYOUTS.ONE_TWO_THIRDS_COLUMN]: 'layout 1/3 2/3 column',
  [LAYOUTS.TWO_ONE_THIRDS_COLUMN]: 'layout 2/3 1/3 column'
};

// Returns a string to use for usage logging
export const getLayoutLoggingType = layout => {
  const loggingType = LAYOUT_TYPES_FOR_LOGGING[layout] || layout;
  if (!Object.prototype.hasOwnProperty.call(LAYOUT_TYPES_FOR_LOGGING, layout)) {
    console.warn(`Missing logging friendly type name for layout type ${layout}`);
  }
  return loggingType;
};
export const getLayoutLoggingTypeForSection = section => {
  const sectionLayout = getLayoutForSection(section);
  return getLayoutLoggingType(sectionLayout);
};
const MODULE_TYPES_FOR_LOGGING = {
  [MODULE_TYPES.IMAGE]: 'image',
  [MODULE_TYPES.BUTTON]: 'button',
  [MODULE_TYPES.RICH_TEXT]: 'text',
  [MODULE_TYPES.DIVIDER]: 'divider',
  [MODULE_TYPES.HTML]: 'html',
  [MODULE_TYPES.SOCIAL_SHARING]: 'social sharing',
  [MODULE_TYPES.FOOTER]: 'footer',
  [MODULE_TYPES.EMAIL_PRODUCTS]: 'product',
  [MODULE_TYPES.EMAIL_CART]: 'cart'
};

// Returns a string to use for usage logging
export const getModuleLoggingType = moduleId => {
  const moduleType = getModuleType(moduleId);
  const loggingType = MODULE_TYPES_FOR_LOGGING[moduleType] || moduleType || 'custom';
  return loggingType;
};
const ALLOWED_MODULE_FIELD_TRACKING = {
  button_email: ['link_to', 'subscription_type', 'unsubscribe_action'],
  email_footer: ['unsubscribe_link_type', 'unsubscribe_action']
};
export const shouldTrackModuleUpdate = (defaultType, key) => {
  return ALLOWED_MODULE_FIELD_TRACKING[defaultType] && ALLOWED_MODULE_FIELD_TRACKING[defaultType].includes(key);
};
export const trackReviewReasonsInteraction = event => {
  UsageTracker.trackEditorInteraction({
    action: 'Review Reasons',
    event
  });
};
export const trackReviewReasonsViewListInteraction = filterReason => trackReviewReasonsInteraction(`view-${filterReason.toLowerCase()}-drop-list`);
export const trackReviewReasonsRecommendationInteraction = filterReason => trackReviewReasonsInteraction(`recommendation-${filterReason.toLowerCase()}`);
export const trackOptimizeOpenRateInteraction = event => {
  UsageTracker.trackEditorInteraction({
    action: 'Optimize Open Rate',
    event
  });
};